<!--
  ~ Copyright 2023. NXGN Management, LLC. All Rights Reserved.
  -->

<div class="modal-content border-0">
  <div class="modal-header">
    <div class="modal-title">{{ modalData?.title }}</div>
  </div>
  <div class="modal-body" *ngIf="!isMigrationModal">
    {{ modalData.message.mainMessage }}
    <ul class="migration-modal-list">
      <li *ngFor="let submessage of modalData.message?.submessages">
        {{ submessage }}
      </li>
    </ul>
  </div>
  <div class="modal-body" *ngIf="isMigrationModal">
    {{ modalData.errorMessage }}
    <ul
      class="migration-modal-ul migration-modal-list"
      *ngIf="modalData.error && modalData.merchantMigrationSummaries.length"
    >
      <li *ngFor="let merchant of modalData.merchantMigrationSummaries">
        {{ merchant.merchantName }}
      </li>
    </ul>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      (click)="cancel()"
      class="btn btn-light"
      *ngIf="modalData.displayButtons.showCancelBtn"
    >
      <span class="oi oi-x"></span>
      {{
        !isMigrationModal && !modalData.message?.submessages
          ? "Close"
          : "Cancel"
      }}
    </button>
    <button
      type="button"
      (click)="handleConfirm()"
      class="btn btn-primary"
      *ngIf="modalData.displayButtons.showConfirmBtn"
    >
      <span>
        <fa-icon [icon]="faCheck"></fa-icon>
      </span>
      Confirm
    </button>
  </div>
</div>
